import React from 'react';
import { Sparklines, SparklinesLine } from 'react-sparklines';

const MiniLineChart = ({data, percent}) => (
  <div style={styles.container}>
      <div style={styles.change}>
          <span style={{color: color(percent)}}>{(percent).toFixed(2)}%</span>
      </div>
      
      <div style={styles.chart}>
          <Sparklines data={data} width={50} height={20}>
              <SparklinesLine style={{ fill: "none" }} color={color(percent)}/>
          </Sparklines>
      </div>  
  </div>
)

const styles = {
    container: {
        display: 'inline-flex',
        alignItems: 'end'
    },

    chart: {
        width: '50px',
        height: '20px'
    },

    change: {
        fontSize: '13px',
        marginRight: '3px'
    }
}

const color = (v) => {
    if (v >= 0) return "#19BE87";
    else return "#F72121";
}

export default MiniLineChart;
